<template>
  <!-- 底部组件 -->
  <div class="footerBottomTxt">
    <ul>
      <li class="address">北京市东城区前门大街大江胡同131号</li>
      <li class="zizhi">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302007215" target="view_window">
          <img src="@/assets/bot1.png">京公网安备11011302007215号
        </a> |
        <a href="https://beian.miit.gov.cn/" target="view_window">ICP备10216796号-6<img src="@/assets/bot2.png"></a>
        <!-- <a href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202006041400015"> -->

        <!-- </a> -->
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'footerComponent',
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
.footerBottomTxt {
  width: 100%;
  background: #5d5d5d;
  padding: 10px 0;

  ul li {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
    font-size: 12px;
    color: #b0b0b0;

    a {
      color: #b0b0b0;
      display: flex;
      align-items: center;
    }

    img {
      width: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent/footerBottomTxt.vue